import { render } from "./HomeView.vue?vue&type=template&id=8e87d1e6&scoped=true"
const script = {}

import "./HomeView.vue?vue&type=style&index=0&id=8e87d1e6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_bb4469d58753dffd1fec5b0ad5bf78e8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e87d1e6"]])

export default __exports__